/**
 * Types and constants for ChatOrderSheet and its handler hook.
 */

export interface CheckoutLinkPayload {
  url: string;
  grand_total: number;
  subtotal: number;
  currency: string;
  shipping?: number;
  products: { item_code: string; item_name: string; qty: number; rate: number; price: number; currency: string; image_url?: string }[];
  customer?: { name: string; phone: string };
}

export type Step = "products" | "checkout";

export interface AddressForm {
  address_title: string;
  phone: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  pincode: string;
}

export const EMPTY_ADDRESS: AddressForm = {
  address_title: "",
  phone: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  pincode: "",
};

/** Single item row from the Quotation (base item or addon) */
export interface PreviewItem {
  item_code: string;
  item_name: string;
  qty: number;
  rate: number;
  amount: number;
  is_addon: boolean;
  row_name?: string;
}

export interface AppliedCoupon { code: string; type: string; valid: boolean; message?: string }

/** ERPNext-calculated totals from the real Quotation */
export interface PreviewResult {
  quotation_name: string;
  subtotal: number;
  discount_amount: number;
  product_discount?: number;
  shipping_discount?: number;
  embroidery_discount?: number;
  shipping_amount: number;
  grand_total: number;
  currency: string;
  coupon_valid: boolean;
  coupon_type: string;
  coupon_message: string;
  applied_coupons: AppliedCoupon[];
  item_count: number;
  items: PreviewItem[];
}
